import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { AdminService } from '../admin.service';
import { Provider } from '@models/mood/general/provider';
import { ActivatedRoute, Router } from '@angular/router';
import { v4 } from 'uuid';
import { TopBarService } from 'src/app/top-bar/top-bar.service';

@Component({
  selector: 'mood-provider-list-admin',
  templateUrl: './provider-list.component.html',
  styleUrls: ['provider-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProviderListAdminComponent implements OnInit, OnDestroy {
  selectedProviderId?: string;

  providerList: Provider[] = [];

  constructor(private _adminService: AdminService,
    private _changeDetector: ChangeDetectorRef,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _topBarService: TopBarService,
  )
  {
    this._topBarService.setTitle('Provider List');
  }

  ngOnDestroy(): void {
  }

  async ngOnInit() {
    await this._loadProviderList();

    this._activatedRoute.queryParams.subscribe(params => {
      this.selectedProviderId = params['id'];
      this._changeDetector.markForCheck();
    });

    this._adminService.providerUpdated.subscribe(async _ => {
      await this._loadProviderList();
    });
  }

  async _loadProviderList() {
    this.providerList = await this._adminService.getProviders()
    this._changeDetector.markForCheck();
  }

  addNewProvider() {
    this._navigateToProvider(v4());
  }

  public providerClicked(provider_id: string) {
    this._navigateToProvider(provider_id);
  }

  private _navigateToProvider(provider_id: string) {
    this._router.navigate(
      [],
      {
        relativeTo: this._activatedRoute,
        queryParams: {
          id: provider_id
        }
      }
    );
  }
}

